import * as gateway from 'sfx-web-contract';
import { AlkLogger } from '@alk/core';
import { COMMUNICATION_SERVICE, ICommunicationService } from '../../communication';
import { decodeFeedbackResponse } from './feedback-adapter.service.utils';
import { DeepRequired } from '../../../types';
import { filter, finalize, map, take, takeUntil, tap } from 'rxjs/operators';
import { IFeedbackAdapterService } from './feedback-adapter.interface';
import {
    IFeedbackMessageRequest,
    IFeedbackMessageResponse,
} from '../../../interfaces/feedback.interface';
import { inject, injectable } from 'inversify';
import { ISessionLifecycle, SESSION_LIFECYCLE_SERVICE } from '../../session-lifecycle';
import { IStreamData } from '../../../interfaces';
import { Observable } from 'rxjs';

@injectable()
export class FeedbackAdapterService implements IFeedbackAdapterService {
    @inject(COMMUNICATION_SERVICE) private readonly communicationService: ICommunicationService;
    @inject(SESSION_LIFECYCLE_SERVICE) private readonly sessionLifeCycle: ISessionLifecycle;

    sendFeedback(feedbackRequest: IFeedbackMessageRequest): Promise<IFeedbackMessageResponse> {

        AlkLogger.info(`[FeedbackAdapterService#cancel] sendFeedback is about to send`, feedbackRequest);

        const request: DeepRequired<gateway.IFeedbackRequest> = {
            Message: feedbackRequest.message,
            ImageData: Boolean(feedbackRequest.imageData) ?
                gateway.google.protobuf.StringValue.create({ value: feedbackRequest.imageData }) :
                undefined,
        };

        const message = gateway.FeedbackRequest.encode(
            gateway.FeedbackRequest.create(request),
        ).finish();

        const requestId = this.communicationService.create(message, gateway.MessageTypes.Feedback);

        return this.feedbackRequestFeed().pipe(
            filter(response => response.communicationToken === requestId),
            finalize(() => this.communicationService.delete(requestId)),
            tap((response) =>
                AlkLogger.info(`[FeedbackAdapterService#sendFeedback] response feedback ${ ''
                }${ JSON.stringify(request) } is ${ JSON.stringify(response) }`)),
            take(1),
            map(decodeFeedbackResponse),
        ).toPromise();
    }

    private readonly feedbackRequestFeed = (): Observable<IStreamData<Uint8Array>> =>
        this.communicationService.dataObservable(gateway.MessageTypes.Feedback)
            .pipe(
                takeUntil(this.sessionLifeCycle.destroyObservable()),
            );
}
